<template>
  <div class="personal-counter-progress-linear">
    <div
      :style="progress"
      class="personal-counter-progress-linear__progress"
      data-test-id="personal-counter-progress-linear"
    />
  </div>
</template>

<script>
export default {
  name: 'EPersonalCounterProgressLinear',
  props: {
    percentage: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    progress() {
      return {
        width: `${this.percentage * 100}%`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.personal-counter-progress-linear,
.personal-counter-progress-linear__progress {
  border-radius: $border-radius-2s;
  height: 2px;
}

.personal-counter-progress-linear {
  background-color: var(--color-background-quaternary);
  width: 100%;
}

.dark .personal-counter-progress-linear {
  background-color: var(--color-disabled);
}

.personal-counter-progress-linear__progress {
  background-color: var(--color-brand-primary);
  transition: width $timing-m;
  width: 0;
}
</style>
